import apiClient from './apiClient';
import { getFallbackSeo, normalizeSeoPath } from '../data/seoDefaults';

const seoCache = new Map();

export async function getPublicSeo(pathname) {
  const path = normalizeSeoPath(pathname);
  if (seoCache.has(path)) {
    return seoCache.get(path);
  }

  try {
    const response = await apiClient.get('/api/seo/public', {
      params: { path },
    });
    const payload = {
      global: response.data.global,
      page: response.data.page,
      sitemap: response.data.sitemap,
    };
    seoCache.set(path, payload);
    return payload;
  } catch (error) {
    const fallback = getFallbackSeo(path);
    seoCache.set(path, fallback);
    return fallback;
  }
}

export function clearSeoCache() {
  seoCache.clear();
}
